// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RGRE","toggle":"styles_toggle__2WsJY","preview":"styles_preview__3Z3aU"};